// Detect schedule items that overlap a fixed calendar event.
//
// Calendar events (type "event") are immovable. Any non-event, non-class item
// (a task, meal, or break) whose time range overlaps an event's range is a
// conflict the user needs to resolve. Classes are excluded because they are
// treated as fixed alongside events, not scheduled against them.
//
// Overlap is half-open: [start, end). Items that merely touch at a boundary
// (one ends exactly when another begins) do NOT conflict.
//
// @param {Array<{time: string, endTime: string, type: string}>} items
//   Schedule items with "HH:MM" 24-hour times.
// @returns {Set<number>} indices (into `items`) of conflicting items.
export function detectCalendarConflicts(items) {
  const events = []
  items.forEach((item, idx) => {
    if (item.type === 'event') {
      const [h1, m1] = item.time.split(':').map(Number)
      const [h2, m2] = item.endTime.split(':').map(Number)
      events.push({ idx, start: h1 * 60 + m1, end: h2 * 60 + m2 })
    }
  })
  const conflicts = new Set()
  items.forEach((item, idx) => {
    if (item.type === 'event' || item.type === 'class') return
    const [h1, m1] = item.time.split(':').map(Number)
    const [h2, m2] = item.endTime.split(':').map(Number)
    const start = h1 * 60 + m1
    const end = h2 * 60 + m2
    for (const ev of events) {
      if (start < ev.end && ev.start < end) {
        conflicts.add(idx)
        break
      }
    }
  })
  return conflicts
}
